// extracted by mini-css-extract-plugin
export var blockRecommendedVideos = "RecommendedVideos-module--block-recommended-videos--3F2wn";
export var articleMeta = "RecommendedVideos-module--article-meta--2B9z9";